import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Configuration from "@/pages/Configuration";
import Queue from "@/pages/Queue";
import Webhooks from "@/pages/Webhooks";
import Partners from "@/pages/Partners";

const TOAST_OPTIONS = { style: { fontFamily: "IBM Plex Sans, sans-serif", fontSize: "13px" } };

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/queue"
            element={
              <ProtectedRoute>
                <Queue />
              </ProtectedRoute>
            }
          />
          <Route
            path="/webhooks"
            element={
              <ProtectedRoute>
                <Webhooks />
              </ProtectedRoute>
            }
          />
          <Route
            path="/partners"
            element={
              <ProtectedRoute>
                <Partners />
              </ProtectedRoute>
            }
          />
          <Route
            path="/config"
            element={
              <ProtectedRoute>
                <Configuration />
              </ProtectedRoute>
            }
          />
        </Routes>
        <Toaster
          position="top-right"
          richColors
          toastOptions={TOAST_OPTIONS}
        />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
